import baseApi from "./baseApi"

export default  {
    /**
     * Fetch list of Personnel for the Plants that this user has access to
     * @return {Object} -- Alert Totals
     */
    async getPersonnel(params) {
        let queryString = Object.keys(params)
            .filter(function(key) {
                if (params[key] || params[key] === 0) {
                    return true;
                }

                return false;
            })
            .map(function(key) {
                return key + "=" + encodeURIComponent(params[key]);
            }).join("&");

        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/personnel?${queryString}`);
        
        return result.data;
    },
    async getMovementsHistory(params) {
        let queryString = Object.keys(params)
            .filter(function(key) {
                if (key === "totalItems") {
                    // this seems to be something that should have been removed from the vuetify table component - either way we don't need it here
                    return false;
                }
                
                if (params[key] || params[key] === 0) {
                    return true;
                }

                return false;
            })
            .map(function(key) {
                return key + "=" + encodeURIComponent(params[key]);
            }).join("&");

        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/personnel/movehistory?${queryString}`);

        return result.data;
    },
    async getMovementsHistoryForExport(params) {
        let queryString = Object.keys(params)
            .filter(function(key) {
                if (key === "totalItems") {
                    // this seems to be something that should have been removed from the vuetify table component - either way we don't need it here
                    return false;
                }
                
                if (params[key] || params[key] === 0) {
                    return true;
                }

                return false;
            })
            .map(function(key) {
                return key + "=" + encodeURIComponent(params[key]);
            }).join("&");

        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/personnel/movehistoryexport?${queryString}`);

        return result;
    },
    async getPlantsWithTeams() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/personnel/plantsWithTeams`);
        
        return result.data;
    },
    async getRoleTypes() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/personnel/roleTypes`);
        
        return result.data;
    },
    async savePersonnelMovementUpdates(data) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post('/personnel/move', data);

        return result.data;
    }
}